

function initCountup() {

    let countUpHolders = document.querySelectorAll('.count-up-holder');


    countUpHolders.forEach(countUpHolder => {

        let target      = countUpHolder.querySelector('.count-up-number');
        let targetId    = countUpHolder.querySelector('.count-up-number').id;
        let value       = countUpHolder.dataset.value;
        let duration    = countUpHolder.dataset.duration;
        let startVal    = countUpHolder.dataset.startVal;
        
        var countUp = new CountUp(targetId, value, {
            startVal: startVal,
            separator: '.',
            //enableScrollSpy: true,
            duration: duration,
            //scrollSpyDelay: 1
        });


        const configCountUp = {
            trigger: countUpHolder,
            onEnter: () => {
                countUp.start();
                //console.log('onEnter');
            },
            onLeave: () => {
                //console.log('onLeave');
            },
            onLeaveBack: () => {

                //console.log('onLeaveBack');
                countUp.reset();
            },
            onEnterBack: () => {
                //countUp.start();
                //console.log('onEnterBack');
            },
            
            start: 'top bottom',
            end:  'bottom top', 
          }
         ScrollTrigger.create(configCountUp);
      

    })
}